module.exports = __webpack_public_path__ + "static/media/segu.115c68c3.webp";